import React from 'react';
import { Box, Chip } from '@mui/material';
import type { ProcedureType } from '../../../../../../services/EncounterService/types/encounterTypes';

interface PrimaryServiceDisplayProps {
  isPrimary?: boolean;
}

/**
 * Display component for primary/secondary service indicator
 */
export const PrimaryServiceDisplay: React.FC<PrimaryServiceDisplayProps> = ({ isPrimary }) => (
  <Box sx={{ display: 'flex', justifyContent: 'center' }}>
    {isPrimary ? (
      <Chip 
        label="Primary" 
        size="small" 
        color="primary" 
        sx={{ fontWeight: 600 }}
      />
    ) : (
      <Chip 
        label="Secondary" 
        size="small" 
        variant="outlined" 
        color="default"
      />
    )}
  </Box>
);

/**
 * Grid template wrapper for primary service indicator
 */
export const primaryServiceTemplate = (props: ProcedureType) => (
  <PrimaryServiceDisplay isPrimary={props.isPrimary} />
);

export default PrimaryServiceDisplay;
